module.exports = __webpack_public_path__ + "da654bc9bb19f215f075b8b66c49b437.svg";